<template>
    <div>
        <bc-circle-loader v-if="loading == true"></bc-circle-loader>
        <v-container v-else fluid grid-list-xl class="toolbar-container">
            <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                <v-toolbar color="grey lighten-3" elevation="1">
                    <bc-btn-back></bc-btn-back>
                    <v-toolbar-title class="ml-0">{{
                        quote_request.quote_request_id ? $t("lang.edit_quote_request") : $t("lang.add_quote_request")
                    }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <bc-modal-print
                        ref="print"
                        @close-method="(file_name = null), $refs.print.close()"
                        :file-name="file_name"
                        :no-button="true"
                    ></bc-modal-print>
                    <bc-btn-refresh
                        v-if="quote_request.quote_request_id && quote_request.quote_request_id > 0"
                        @invoke-method="dbGetQuoteRequest(true)"
                    ></bc-btn-refresh>
                    <v-menu
                        left
                        content-class="no-stripe"
                        v-if="quote_request.quote_request_id && quote_request.quote_request_id > 0 && current_user.login_type_id != '2'"
                    >
                        <template slot="activator">
                            <v-btn icon>
                                <v-icon>more_vert</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-tile @click="convertToEstimate()" v-if="quote_request.status_id >= 56 && quote_request.status_id != 164">
                                <v-list-tile-title> Create Estimate </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="convertToVendorRFQs()" v-if="quote_request.status_id >= 56 && quote_request.status_id != 164">
                                <v-list-tile-title> Create Vendor RFQs </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="createPurchaseOrderFromQR()" v-if="quote_request.status_id >= 56 && quote_request.status_id != 164">
                                <v-list-tile-title> Create Purchase Order </v-list-tile-title>
                            </v-list-tile>
                            <!--<template v-if="hasPerm('quote_requests.update')">
                                <v-divider class="ml-3 my-0"></v-divider>

                                <div v-for="item in quote_request_status" :key="item.option_id">
                                    <v-list-tile @click="changeStatus(item)" v-if="item.option_id != quote_request.status_id">
                                        <v-list-tile-title>
                                            {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                        </v-list-tile-title>
                                    </v-list-tile>
                                </div>
                            </template>-->
                            <template v-if="hasPerm('quote_requests.delete')">
                                <v-divider class="ml-3 my-0"></v-divider>
                                <v-list-tile @click="$refs.delete_quote_request.openDialog()">
                                    <v-list-tile-title> Delete </v-list-tile-title>
                                </v-list-tile>
                            </template>
                        </v-list>
                    </v-menu>
                    <bc-tooltip>
                        <template slot="activator">
                            <v-btn icon @mouseup.left="$router.push({ name: 'quote_requests' })">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </template>
                        {{ $t("lang.back_to_list") }}
                    </bc-tooltip>
                </v-toolbar>
            </v-layout>
        </v-container>

        <v-container v-if="loading == false" fluid grid-list-xl :class="$bp.smallScreen ? 'pl-0 pr-0' : null">
            <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                <bc-transaction-links :items="quote_request.transaction_links" :object_id="quote_request.quote_request_id"></bc-transaction-links>
                <v-flex :class="quote_request.quote_request_id != null ? 'lg10 md9 xs12' : 'lg12 md12 xs12'" pb-0 mb-0>
                    <v-card elevation="0">
                        <v-card-text :class="$bp.smallScreen ? 'pl-0 pr-0' : null">
                            <div v-if="quote_request.status" class="ribbon ribbon-top-right" :class="`ribbon-${quote_request.status_class}`">
                                <span class="ribbon-span">{{ quote_request.status }}</span>
                            </div>

                            <vue-perfect-scrollbar
                                class="scroll-area"
                                :style="$bp.xs ? null : 'max-height: calc(100vh - 260px); min-height: calc(100vh - 260px)'"
                            >
                                <v-form ref="formQuoteRequest">
                                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                        <v-flex xs12 sm6 row-2-fr1>
                                            <v-layout row wrap>
                                                <v-flex xs12>
                                                    <bc-autocomplete
                                                        v-if="quote_request.status_id != 164"
                                                        v-model="quote_request.company_id"
                                                        :label="`${$t('lang.customer')} *`"
                                                        :items="filter_customer_options"
                                                        item-value="company_id"
                                                        item-text="company"
                                                        :rules="ifValid('quote_requests.company_id')"
                                                        @change="selectCustomer(quote_request.company_id)"
                                                        :disabled="
                                                            current_user.login_type_id != '2' &&
                                                            (quote_request.status_id == '56' || quote_request.status_id == null)
                                                                ? false
                                                                : true
                                                        "
                                                        :append-icon="
                                                            current_user.login_type_id != '1' &&
                                                            (quote_request.status_id == '56' || quote_request.status_id == null)
                                                                ? 'lock'
                                                                : 'arrow_drop_down'
                                                        "
                                                        hide-details
                                                    ></bc-autocomplete>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                <v-flex xs12 sm6>
                                                    <div class="customer-address" v-if="quote_request.billing_address_id != null">
                                                        <h3>
                                                            {{ $t("lang.billing_address_id") }}
                                                            <v-btn
                                                                v-if="quote_request.status_id != 164"
                                                                color="secondary"
                                                                icon
                                                                small
                                                                @mouseup.left="changeAddress('bill_address')"
                                                            >
                                                                <v-icon small>edit</v-icon>
                                                            </v-btn>
                                                        </h3>
                                                        <div>
                                                            <div>
                                                                <div>
                                                                    <div v-if="quote_request.bill_location_label">{{ quote_request.bill_location_label }}</div>
                                                                    <div>{{ quote_request.bill_address1 }}</div>
                                                                    <div v-if="quote_request.bill_address2 != ''">
                                                                        {{ quote_request.bill_address2 }}
                                                                    </div>
                                                                    <div>
                                                                        {{ quote_request.bill_city }}, {{ quote_request.bill_state }},
                                                                        {{ quote_request.bill_zip_code }}
                                                                    </div>
                                                                    <div>{{ quote_request.bill_country_iso_3 }}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <div class="customer-address" v-if="quote_request.shipping_address_id != null">
                                                        <h3>
                                                            {{ $t("lang.shipping_address_id") }}
                                                            <v-btn
                                                                v-if="quote_request.status_id != 164"
                                                                color="secondary"
                                                                icon
                                                                small
                                                                @mouseup.left="changeAddress('ship_address')"
                                                            >
                                                                <v-icon small>edit</v-icon>
                                                            </v-btn>
                                                        </h3>
                                                        <div>
                                                            <div>
                                                                <div>
                                                                    <div v-if="quote_request.ship_location_label">{{ quote_request.ship_location_label }}</div>
                                                                    <div>{{ quote_request.ship_address1 }}</div>
                                                                    <div v-if="quote_request.ship_address2 != ''">
                                                                        {{ quote_request.ship_address2 }}
                                                                    </div>
                                                                    <div>
                                                                        {{ quote_request.ship_city }}, {{ quote_request.ship_state }},
                                                                        {{ quote_request.ship_zip_code }}
                                                                    </div>
                                                                    <div>{{ quote_request.ship_country_iso_3 }}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex xs12 sm6 class="pa-0">
                                            <v-flex xs12 v-if="quote_request.quote_request_id">
                                                <v-text-field
                                                    v-model="quote_request.quote_request_id"
                                                    :label="$t('lang.quote_request_id')"
                                                    :counter="showCounter(quote_request.quote_request_id, 'quote_requests.quote_request_id')"
                                                    :rules="ifValid('quote_requests.quote_request_id')"
                                                    v-readonly-click
                                                ></v-text-field>
                                            </v-flex>
                                            <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                <v-flex xs12 sm6>
                                                    <bc-date-picker
                                                        v-if="current_user.login_type_id != '2'"
                                                        v-model="quote_request.request_date"
                                                        :label="`${$t('lang.request_date')} *`"
                                                        :rules="ifValid('quote_requests.request_date')"
                                                    ></bc-date-picker>
                                                    <bc-date-picker
                                                        v-else
                                                        v-model="quote_request.request_date"
                                                        :label="`${$t('lang.request_date')} *`"
                                                        :rules="ifValid('quote_requests.request_date')"
                                                        append-icon="lock"
                                                        v-readonly-click
                                                    ></bc-date-picker>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="quote_request.reference_number"
                                                        :label="$t('lang.customer_reference_number')"
                                                        :counter="showCounter(quote_request.reference_number, 'quote_requests.reference_number')"
                                                        :rules="ifValid('quote_requests.reference_number')"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <!-- <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                <v-flex xs12 sm6>
                                                    <bc-autocomplete
                                                        v-model="quote_request.shipping_carrier_id"
                                                        :label="$t('lang.shipping_carrier_id')"
                                                        :items="filter_shipping_carriers"
                                                        item-value="company_id"
                                                        item-text="company"
                                                        :rules="ifValid('quote_requests.shipping_carrier_id')"
                                                    ></bc-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <bc-autocomplete
                                                        v-model="quote_request.freight_term_id"
                                                        :label="$t('lang.freight_term_id')"
                                                        :items="filter_freight_terms"
                                                        item-value="option_id"
                                                        item-text="option"
                                                        :rules="ifValid('quote_requests.freight_term_id')"
                                                    ></bc-autocomplete>
                                                </v-flex>
                                            </v-layout> -->
                                            <v-layout
                                                row
                                                wrap
                                                :class="$bp.smallScreen ? 'mx-0' : null"
                                                style="margin: 0px"
                                                v-if="current_user.login_type_id != '2'"
                                            >
                                                <v-flex xs12 sm6>
                                                    <bc-autocomplete
                                                        v-if="current_user.login_type_id != '2'"
                                                        v-model="quote_request.currency_id"
                                                        :label="$t('lang.document_currency')"
                                                        :items="filter_currencies"
                                                        item-value="currency_id"
                                                        item-text="name"
                                                        :rules="ifValid('quote_requests.currency_id')"
                                                        @change="setExchangeRate(quote_request.currency_id)"
                                                    ></bc-autocomplete>
                                                    <bc-autocomplete
                                                        v-else
                                                        v-model="quote_request.currency_id"
                                                        :label="$t('lang.document_currency')"
                                                        :items="filter_currencies"
                                                        item-value="currency_id"
                                                        item-text="name"
                                                        append-icon="lock"
                                                        v-readonly-click
                                                    ></bc-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-if="current_user.login_type_id != '2'"
                                                        v-model="quote_request.exchange_rate"
                                                        :label="$t('lang.exchange_rate')"
                                                        :counter="showCounter(quote_request.exchange_rate, 'quote_requests.exchange_rate')"
                                                        :rules="ifValid('quote_requests.exchange_rate')"
                                                    ></v-text-field>
                                                    <v-text-field
                                                        v-else
                                                        v-model="quote_request.exchange_rate"
                                                        :label="$t('lang.exchange_rate')"
                                                        append-icon="lock"
                                                        v-readonly-click
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>

                                    <div>
                                        <v-data-table
                                            :headers="headers"
                                            :items="quote_request.quote_request_details || []"
                                            item-key="quote_request_detail_id"
                                            :no-data-text="$t('lang.no_results_matching')"
                                            hide-actions
                                            class="custom-table"
                                        >
                                            <template slot="items" slot-scope="props">
                                                <tr>
                                                    <td>
                                                        <!-- <bc-autocomplete
                                                            v-model="props.item.part_id"
                                                            :items="filter_fe_part_options(props.item)"
                                                            item-value="part_id"
                                                            item-text="sales_sku"
                                                            @change="handleChangePart(props.index, props.item.part_id)"
                                                            :rules="ifValid('quote_requests.quote_request_details.part_id')"
                                                        ></bc-autocomplete> -->
                                                        <bc-autocomplete
                                                            v-if="props.item.part_id == null"
                                                            v-model="props.item.part_id"
                                                            :items="filter_fe_part_options(props.item)"
                                                            item-value="part_id"
                                                            item-text="sales_sku"
                                                            @change="handleChangePart(props.index, props.item.part_id)"
                                                            :rules="ifValid('quote_requests.quote_request_details.part_id')"
                                                            :append-icon="
                                                                current_user.login_type_id != '1' &&
                                                                (quote_request.status_id == '56' || quote_request.status_id == null)
                                                                    ? 'lock'
                                                                    : 'arrow_drop_down'
                                                            "
                                                            :disabled="
                                                                current_user.login_type_id != '1' &&
                                                                (quote_request.status_id == '56' || quote_request.status_id == null)
                                                                    ? true
                                                                    : false
                                                            "
                                                            :filter="$filterFePartsSales"
                                                            :ref="`${props.index}_detail_id`"
                                                        >
                                                            <template slot="item" slot-scope="data">
                                                                <v-list-tile-content>
                                                                    <v-list-tile-title
                                                                        ><strong>{{ data.item.sales_sku }}</strong></v-list-tile-title
                                                                    >
                                                                    <v-list-tile-sub-title v-html="data.item.name"></v-list-tile-sub-title>
                                                                    <v-list-tile-sub-title v-html="data.item.model_number"></v-list-tile-sub-title>
                                                                </v-list-tile-content>
                                                            </template>
                                                        </bc-autocomplete>
                                                        <v-list-tile v-else class="full-height-tile">
                                                            <v-list-tile-content>
                                                                <v-list-tile-title
                                                                    ><strong>{{ props.item.sales_sku || props.item.sku }}</strong></v-list-tile-title
                                                                >
                                                                <v-list-tile-sub-title>{{ `Name: ${props.item.name}` }}</v-list-tile-sub-title>
                                                                <v-list-tile-sub-title class="v-list__sub-title-nowrap">{{
                                                                    `Model: ${props.item.model_number}`
                                                                }}</v-list-tile-sub-title>
                                                            </v-list-tile-content>
                                                            <v-list-tile-action
                                                                v-if="
                                                                    current_user.login_type_id != '2' &&
                                                                    (quote_request.status_id == '56' || quote_request.status_id == null)
                                                                "
                                                                style="position: absolute; top: 0px; right: 0px; align-items: normal"
                                                            >
                                                                <v-btn icon ripple @click="resetLine(props.index, props.item)">
                                                                    <v-icon color="grey lighten-1">cancel</v-icon>
                                                                </v-btn>
                                                            </v-list-tile-action>
                                                        </v-list-tile>
                                                    </td>
                                                    <td>
                                                        <v-text-field
                                                            v-model="props.item.quantity"
                                                            :rules="ifValid('quote_requests.quote_request_details.quantity')"
                                                            :ref="`${props.index}_quantity`"
                                                            :disabled="
                                                                current_user.login_type_id != '2' &&
                                                                (quote_request.status_id == '56' || quote_request.status_id == null)
                                                                    ? false
                                                                    : true
                                                            "
                                                        ></v-text-field>
                                                    </td>
                                                    <td>
                                                        <bc-autocomplete
                                                            v-model="props.item.sales_unit"
                                                            :items="filter_sales_units(props.item)"
                                                            item-value="option_id"
                                                            item-text="option"
                                                            :rules="ifValid('quote_requests.quote_request_details.sales_unit')"
                                                            :disabled="
                                                                current_user.login_type_id != '2' &&
                                                                (quote_request.status_id == '56' || quote_request.status_id == null)
                                                                    ? false
                                                                    : true
                                                            "
                                                            :append-icon="
                                                                current_user.login_type_id != '1' &&
                                                                (quote_request.status_id == '56' || quote_request.status_id == null)
                                                                    ? 'lock'
                                                                    : 'arrow_drop_down'
                                                            "
                                                        ></bc-autocomplete>
                                                    </td>

                                                    <td>
                                                        <bc-autocomplete
                                                            v-if="current_user.login_type_id != '2'"
                                                            v-model="props.item.map_id"
                                                            :items="filter_fe_part_vendor_mapping(props.item, props.item.fe_part_vendor_mapping)"
                                                            item-value="map_id"
                                                            item-text="vendor_name"
                                                            :rules="ifValid('quote_requests.quote_request_details.map_id')"
                                                        ></bc-autocomplete>
                                                    </td>
                                                    <td v-if="quote_request.status_id != 164">
                                                        <div style="display: flex; align-items: center">
                                                            <bc-tooltip top v-if="current_user.login_type_id != '2'">
                                                                <template slot="activator">
                                                                    <v-checkbox
                                                                        v-model="props.item.require_rfq"
                                                                        true-value="1"
                                                                        false-value="0"
                                                                        class="require-rfq-checkbox"
                                                                        :rules="ifValid('quote_requests.quote_request_details.require_rfq')"
                                                                    >
                                                                    </v-checkbox>
                                                                </template>
                                                                Require RFQ
                                                            </bc-tooltip>

                                                            <v-icon
                                                                v-if="
                                                                    current_user.login_type_id != '2' &&
                                                                    (quote_request.status_id == '56' || quote_request.status_id == null)
                                                                "
                                                                @click="removeRow(props.index)"
                                                                >delete</v-icon
                                                            >
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                        <div
                                            class="text-center"
                                            v-if="current_user.login_type_id != '2' && (quote_request.status_id == '56' || quote_request.status_id == null)"
                                        >
                                            <v-btn v-if="quote_request.status_id != 164" tile color="primary" @click="addRow()">{{
                                                $t("lang.add_more")
                                            }}</v-btn>
                                        </div>
                                    </div>
                                    <v-flex xs12>
                                        <v-textarea
                                            v-model="quote_request.comments"
                                            :label="$t('lang.comments')"
                                            auto-grow
                                            rows="1"
                                            :rules="ifValid('quote_requests.comments')"
                                            :disabled="
                                                current_user.login_type_id != '2' && (quote_request.status_id == '56' || quote_request.status_id == null)
                                                    ? false
                                                    : true
                                            "
                                        ></v-textarea>
                                    </v-flex>
                                    <v-flex xs6>
                                        <bc-autocomplete
                                            v-if="current_user.login_type_id != '2'"
                                            v-model="quote_request.department_id"
                                            :label="$t('lang.department')"
                                            :items="department_options"
                                            item-value="department_id"
                                            item-text="department_name"
                                            :rules="ifValid('quote_requests.department_id')"
                                        ></bc-autocomplete>
                                        <bc-autocomplete
                                            v-else
                                            v-model="quote_request.department_id"
                                            :label="$t('lang.department')"
                                            :items="department_options"
                                            item-value="department_id"
                                            item-text="department_name"
                                            append-icon="lock"
                                            disabled
                                        ></bc-autocomplete>
                                    </v-flex>
                                </v-form>
                            </vue-perfect-scrollbar>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn v-if="quote_request.status_id != 164" @mouseup.left="$router.push({ name: 'quote_requests' })" flat>{{
                                $t("lang.cancel")
                            }}</v-btn>
                            <v-btn
                                v-if="
                                    current_user.login_type_id != '2' &&
                                    (quote_request.status_id == '56' || quote_request.status_id == null) &&
                                    quote_request.status_id != 164
                                "
                                color="success"
                                @click="saveQuoteRequests"
                                >{{ $t("lang.save") }}</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <bc-address-selector ref="select_address_dialog" @eventname="updateAddress"></bc-address-selector>
        <delete-confirmation-dialog
            ref="delete_quote_request"
            headline="Confirm Delete?"
            :heading="$t('lang.delete_quote_request')"
            :message="$t('lang.delete_quote_request_confirm')"
            @onConfirm="deleteQuoteRequests()"
        ></delete-confirmation-dialog>
        <delete-confirmation-dialog
            ref="delete_quote_request_details"
            :heading="$t('lang.delete_package')"
            @onConfirm="confirmDeleteQuoteRequestDetails()"
        ></delete-confirmation-dialog>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import { store } from "Store/store";
import axios from "axios";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],
            headers: [
                { text: this.$t("lang.part_id"), sortable: false, width: "20%" },
                { text: this.$t("lang.quantity"), sortable: false, width: "5%" },
                { text: this.$t("lang.sales_unit"), sortable: false, width: "10%" },
                { text: this.$t("lang.vendor"), sortable: false, width: "20%" },
                { text: "", width: "3%", sortable: false },
            ],
            quote_request: {
                department_id: "",
                billing_address_id: null,
                shipping_address_id: null,
                address_options: [],
                quote_request_details: [],
                currency_id: "1",
                exchange_rate: "1.000000",
            },
            company: {},
            file_name: "",
            dbGetQuoteRequest: _.debounce(this.getQuoteRequest, 1500, { maxWait: 1500, leading: true, trailing: false }),
            loading: true,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchQuoteRequest", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.quote_request) {
                        this.quote_request = this.assignObj2(data.quote_request, this.rules_quote_requests);
                        this.$store.commit("toggleMainMenu", false);
                        this.refresh();
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "quote_requests", replace: true });
                    }
                });
        } else {
            this.refresh();
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchQuoteRequest", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.quote_request) {
                        next((vm) => {
                            vm.quote_request = vm.assignObj2(data.quote_request, vm.rules_quote_requests);
                            vm.$store.commit("toggleMainMenu", false);
                            vm.refresh();
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "quote_requests", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.refresh();
                vm.finishLoader();
            });
        }
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit("resetOptions");
        this.$store.commit("resetCustomers");
        this.$store.commit("resetCurrencies");
        this.$store.commit("resetFeParts");
        this.$store.commit("resetDepartments");
        this.$store.commit("resetShippingCarriers");
        next();
    },
    computed: {
        ...mapState({
            rules_quote_requests: (state) => state.quote_requests.rules_quote_requests,
            quote_request_status_options: (state) => state.settings.quote_request_status_options,
            quote_requests: (state) => state.quote_requests.quote_requests,
            selectedQuoteRequest: (state) => state.quote_requests.selectedQuoteRequest,
            shipping_carriers: (state) => state.shipping_carriers.shipping_carrier_options,
            fe_part_options: (state) => state.fe_parts.fe_part_options,
            department_options: (state) => state.departments.department_options,
            customer_options: (state) => state.customers.customer_options,
            freight_terms: (state) => state.options_categories.freight_terms,
            quote_request_status: (state) => state.options_categories.quote_request_status,
            sales_units: (state) => state.options_categories.sales_units,
            currencies: (state) => state.currencies.currencies,
        }),
        filter_customer_options() {
            return this.customer_options.filter((record) => !record.date_deleted || record.company_id === this.quote_request.company_id);
        },
        filter_freight_terms() {
            return this.freight_terms.filter((record) => !record.date_deleted || record.option_id === this.quote_request.freight_term_id);
        },
        filter_shipping_carriers() {
            return this.shipping_carriers.filter((record) => !record.date_deleted || record.company_id === this.quote_request.shipping_carrier_id);
        },
        filter_currencies() {
            return this.currencies.filter((record) => !record.date_deleted || record.currency_id === this.quote_request.currency_id);
        },
        filter_fe_part_options: function () {
            return function (item) {
                return this.fe_part_options.filter((record) => !record.date_deleted || record.part_id === item.part_id);
            };
        },
        filter_sales_units: function () {
            return function (item) {
                return this.sales_units.filter((record) => !record.date_deleted || record.option_id === item.sales_unit);
            };
        },
        filter_fe_part_vendor_mapping: function () {
            return function (item, fe_part_vendor_mapping_options) {
                if (item.fe_part_vendor_mapping == null) item.fe_part_vendor_mapping = [];
                if (item.map_id == null) return item.fe_part_vendor_mapping;
                return fe_part_vendor_mapping_options.filter((record) => !record.date_deleted || record.map_id === item.map_id);
            };
        },
    },
    methods: {
        ...mapActions([
            "fetchQuoteRequest",
            "saveQuoteRequest",
            "deleteQuoteRequest",
            "printQuoteRequest",
            "convertQuoteRequestToEstimate",
            "convertQuoteRequestToVendorRfqs",
            "fetchCustomers",
            "fetchShippingCarriers",
            "fetchCurrencies",
            "fetchFeParts",
            "fetchDepartments",
            "fetchOptions",
            "fetchFePart",
            "fetchCustomer",
            "savePurchaseOrderFromQuoteRequest",
        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        addRow() {
            if (!this.quote_request.quote_request_details) this.quote_request.quote_request_details = [];
            this.quote_request.quote_request_details.push({
                part_id: null,
                quantity: "",
                require_rfq: "1",
                vendor_id: "",
                fe_part_vendor_mapping: [],
            });
        },
        removeRow: function (index) {
            this.quote_request.quote_request_details.splice(index, 1);
        },
        changeAddress(type) {
            let address_list = this.quote_request.address_options ? this.quote_request.address_options : this.company.entity_addresses || [];
            this.$refs.select_address_dialog.showAddresses(address_list, type);
        },
        updateAddress(item, type) {
            if (type == "bill_address") {
                this.quote_request.bill_location_label = item.location_label;
                this.quote_request.billing_address_id = item.entity_addresses_id;
                this.quote_request.bill_address1 = item.address1;
                this.quote_request.bill_address2 = item.address2;
                this.quote_request.bill_city = item.city;
                this.quote_request.bill_state = item.state;
                this.quote_request.bill_zip_code = item.zip_code;
                this.quote_request.bill_zip_code_ext = item.zip_code_ext;
                this.quote_request.bill_country_iso_3 = item.country_iso_3;
            } else if (type == "ship_address") {
                this.quote_request.ship_location_label = item.location_label;
                this.quote_request.shipping_address_id = item.entity_addresses_id;
                this.quote_request.ship_address1 = item.address1;
                this.quote_request.ship_address2 = item.address2;
                this.quote_request.ship_city = item.city;
                this.quote_request.ship_state = item.state;
                this.quote_request.ship_zip_code = item.zip_code;
                this.quote_request.ship_zip_code_ext = item.zip_code_ext;
                this.quote_request.ship_country_iso_3 = item.country_iso_3;
            }
        },
        getQuoteRequest(pg_refresh = false) {
            this.startLoader();

            this.fetchQuoteRequest({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.quote_request) {
                    this.quote_request = this.assignObj2(data.quote_request, this.rules_quote_requests);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printQuoteRequest({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.quote_request) {
                    if (this.dev_mode) {
                        this.file_name = data.quote_request.file_name;
                    } else {
                        this.$refs.print.printReport(data.quote_request.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveQuoteRequests() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formQuoteRequest")) {
                    let body = this.prepForm(this.quote_request, this.rules_quote_requests);

                    this.saveQuoteRequest({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.quote_request) {
                            this.$router.push({ name: "quote_request", params: { id: data.quote_request.quote_request_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;

            let body = { quote_request_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveQuoteRequest({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.quote_request) {
                    this.quote_request = this.assignObj2(data.quote_request, this.rules_quote_requests);
                }
            });
        },
        deleteQuoteRequests() {
            this.deleteQuoteRequest({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.$refs.delete_quote_request_details.close();
                    this.validationOff();
                    this.$router.push({ name: "quote_requests" });
                }
                this.toggleModalLoader(false);
            });
        },
        convertToEstimate() {
            this.status_loader = true;
            let body = { quote_request_id: `${this.$route.params.id}` };

            this.convertQuoteRequestToEstimate({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.quote) {
                    this.$router.push({ name: "quote", params: { id: data.quote.quote_id } });
                }
            });
        },
        convertToVendorRFQs() {
            this.status_loader = true;
            let body = { quote_request_id: `${this.$route.params.id}` };

            this.convertQuoteRequestToVendorRfqs({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.rfqs) {
                    this.refresh(true);
                }
            });
        },
        selectCustomer(company_id) {
            if (company_id == null) {
                return;
            } else {
                this.fetchCustomer({ id: company_id }).then((data) => {
                    if (data.customer) {
                        this.company = data.customer;

                        this.quote_request.currency_id = this.company.currency_id ? this.company.currency_id : 1;
                        this.quote_request.exchange_rate = this.company.exchange_rate ? this.company.exchange_rate : "1.000";

                        this.quote_request.address_options = this.company.entity_addresses ? this.company.entity_addresses : [];
                        let ship_address = this.company.entity_addresses ? this.company.entity_addresses.filter((x) => x.address_type == "shipping")[0] : null;
                        this.quote_request.ship_location_label = ship_address && ship_address.location_label ? ship_address.location_label : null;
                        this.quote_request.shipping_address_id = ship_address && ship_address.entity_addresses_id ? ship_address.entity_addresses_id : null;
                        this.quote_request.ship_address1 = ship_address && ship_address.address1 ? ship_address.address1 : null;
                        this.quote_request.ship_address2 = ship_address && ship_address.address2 ? ship_address.address2 : null;
                        this.quote_request.ship_city = ship_address && ship_address.city ? ship_address.city : null;
                        this.quote_request.ship_state = ship_address && ship_address.state ? ship_address.state : null;
                        this.quote_request.ship_zip_code = ship_address && ship_address.zip_code ? ship_address.zip_code : null;
                        this.quote_request.ship_zip_code_ext = ship_address && ship_address.zip_code_ext ? ship_address.zip_code_ext : null;
                        this.quote_request.ship_country_iso_3 = ship_address && ship_address.country_iso_3 ? ship_address.country_iso_3 : null;

                        let bill_address = this.company.entity_addresses ? this.company.entity_addresses.filter((x) => x.address_type == "billing")[0] : null;
                        this.quote_request.bill_location_label = bill_address && bill_address.location_label ? bill_address.location_label : null;
                        this.quote_request.billing_address_id = bill_address && bill_address.entity_addresses_id ? bill_address.entity_addresses_id : null;
                        this.quote_request.bill_address1 = bill_address && bill_address.address1 ? bill_address.address1 : null;
                        this.quote_request.bill_address2 = bill_address && bill_address.address2 ? bill_address.address2 : null;
                        this.quote_request.bill_city = bill_address && bill_address.city ? bill_address.city : null;
                        this.quote_request.bill_state = bill_address && bill_address.state ? bill_address.state : null;
                        this.quote_request.bill_zip_code = bill_address && bill_address.zip_code ? bill_address.zip_code : null;
                        this.quote_request.bill_zip_code_ext = bill_address && bill_address.zip_code_ext ? bill_address.zip_code_ext : null;
                        this.quote_request.bill_country_iso_3 = bill_address && bill_address.country_iso_3 ? bill_address.country_iso_3 : null;
                    } else {
                        return;
                    }
                });
            }
        },
        handleChangePart(index, part_id) {
            this.quote_request.quote_request_details[index].part_id = null;
            let partObj = this.fe_part_options.find((x) => x.part_id == part_id);
            this.fetchFePart({ id: partObj.part_id }).then((data) => {
                if (typeof data !== "undefined" && data.fe_part) {
                    partObj = data.fe_part;
                    this.quote_request.quote_request_details[index].part_id = partObj.part_id;
                    this.quote_request.quote_request_details[index].quantity = partObj.quantity;
                    this.quote_request.quote_request_details[index].model_number = partObj.model_number;
                    this.quote_request.quote_request_details[index].mfg_name = partObj.mfg_name;
                    this.quote_request.quote_request_details[index].mfg_id = partObj.mfg_id;
                    this.quote_request.quote_request_details[index].sales_unit = partObj.sales_unit;
                    this.quote_request.quote_request_details[index].name = partObj.name;
                    this.quote_request.quote_request_details[index].vendor_id = partObj.preferred_vendor_id;
                    this.quote_request.quote_request_details[index].lead_time = partObj.lead_time;
                    this.quote_request.quote_request_details[index].fe_part_vendor_mapping = partObj.fe_part_vendor_mapping;
                    this.quote_request.quote_request_details[index].map_id = partObj.preferred_vendor_map_id;
                    this.quote_request.quote_request_details[index].sales_sku = partObj.sales_sku;
                    // this.quote_request.quote_request_details[index].hts_code = partObj.hts_code;
                    this.$refs[`${index}_quantity`].$el.querySelector("input").focus();
                }
            });
        },
        setExchangeRate(currency_id) {
            let exchange_rate = this.currencies.find((x) => x.currency_id == currency_id);
            this.quote_request.currency_id = exchange_rate.currency_id;
            this.quote_request.exchange_rate = exchange_rate.exchange_rate ? exchange_rate.exchange_rate : "1.000";
        },
        createPurchaseOrderFromQR() {
            this.savePurchaseOrderFromQuoteRequest({
                id: this.$route.params.id,
            }).then((data) => {
                if (typeof data != "undefined" && data.purchase_orders) {
                    this.refresh(true);
                }
            });
        },
        resetLine(index, item) {
            this.quote_request.quote_request_details[index].part_id = null;
            this.quote_request.quote_request_details[index].cost_price = null;
            this.quote_request.quote_request_details[index].unit_price = null;
            this.quote_request.quote_request_details[index].model_number = null;
            this.quote_request.quote_request_details[index].sales_unit = null;
            this.quote_request.quote_request_details[index].name = null;
            this.quote_request.quote_request_details[index].lead_time = null;
            this.quote_request.quote_request_details[index].hts_code = null;
            this.quote_request.quote_request_details[index].line_description = null;
            this.quote_request.quote_request_details[index].map_id = null;

            this.$nextTick(() => {
                this.$refs[`${index}_detail_id`].$children[0].focus();
                this.$refs[`${index}_detail_id`].$children[0].isMenuActive = true;
            });
        },
        async refresh(force = false, show_banner = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchQuoteRequest({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.quote_request) {
                        this.quote_request = this.assignObj2(data.quote_request, this.rules_quote_requests);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(show_banner);
                    }
                });
            }

            if (this.quote_request.status_id == 164) {
                this.headers.pop();
            } else {
                this.headers = [
                    { text: this.$t("lang.part_id"), sortable: false, width: "20%" },
                    { text: this.$t("lang.quantity"), sortable: false, width: "5%" },
                    { text: this.$t("lang.sales_unit"), sortable: false, width: "20%" },
                    { text: this.$t("lang.vendor"), sortable: false, width: "20%" },
                    { text: "", width: "3%", sortable: false },
                ];
            }

            if (this.current_user.login_type_id == "2") {
                this.headers.splice(3, 1);
                this.headers[4] = { text: "", sortable: false, width: "auto" };
                console.log(this.headers);
            }
            if (this.quote_request.request_date == null || force == true) this.quote_request.request_date = new Date().toISOString().slice(0, 10);

            //if (this.customer_options.length == 0 || force == true)
            this.fetchCustomers({ body: { options: 1, with_trashed: this.quote_request.quote_request_id ? "1" : "0" } });

            if (this.currencies.length == 0 || force == true)
                this.fetchCurrencies({ body: { options: 1, with_trashed: this.quote_request.quote_request_id ? "1" : "0" } });

            //if (this.fe_part_options.length == 0 || force == true)
            this.fetchFeParts({ body: { options: 1, with_trashed: this.quote_request.quote_request_id ? "1" : "0" } });

            if (this.freight_terms == 0 || force == true)
                this.fetchOptions({ body: { slug: "freight_terms", with_trashed: this.quote_request.quote_request_id ? "1" : "0", options: 1 } });

            if (this.quote_request_status == 0 || force == true)
                this.fetchOptions({ body: { slug: "quote_request_status", with_trashed: this.quote_request.quote_request_id ? "1" : "0", options: 1 } });

            if (this.sales_units == 0 || force == true)
                this.fetchOptions({
                    body: { slug: "sales_units", sort_by: "0", with_trashed: this.quote_request.quote_request_id ? "1" : "0", options: 1 },
                });

            if (this.department_options.length == 0 || force == true) {
                this.fetchDepartments({ body: { options: 1 } });
                if (this.current_user.slug == "customer") {
                    this.quote_request.department_id = "1";
                }
            }

            if (!this.quote_request.department_id) this.quote_request.department_id = this.currUserField("department_id");

            if (this.shipping_carriers.length == 0 || force == true)
                await this.fetchShippingCarriers({ body: { options: 1, with_trashed: this.quote_request.quote_request_id ? "1" : "0", department_id: "1" } });

            this.loading = false;
            this.finishLoader();
        },
    },
};
</script>
<style lang="css">
.ui-col-2 {
    display: flex;
    flex-wrap: wrap;
}

.column {
    flex: 1;
    padding: 10px;
    box-sizing: border-box;
}

.left-column {
    order: 1;
}

.right-column {
    order: 2;
}

.require-rfq-checkbox * {
    margin-bottom: 0px !important;
}

.custom-table .v-table tbody tr td {
    vertical-align: top !important;
}

.full-height-tile .v-list__tile {
    height: 100% !important;
}

.full-height-tile .v-list__sub-title-nowrap {
    white-space: unset !important;
}

.custom-textarea textarea {
    padding-right: 0px !important;
    font-size: 14px;
    margin-top: 0px !important;
    padding: 4px !important;
}

.custom-textarea .v-input__slot {
    padding: 0px !important;
    border: 1px solid rgba(0, 0, 0, 0.54) !important;
}
</style>
